import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { IoClose } from "react-icons/io5";

const AddStaffMeetingForm = ({ onSubmit, editData, open, onClose, error }) => {
    const {t}=useTranslation();
    const [formData, setFormData] = useState({
        id: null, // ✅ Add ID to state
        name: "",
        date: "",
        time: "",
        meetingPlace: "",
        active: true
    });

    useEffect(() => {
        if (open) {
            if (editData) {
                setFormData({
                    id: editData.id || null, // ✅ Ensure ID is captured
                    name: editData.name || "",
                    date: editData.date || "",
                    time: editData.time || "",
                    meetingPlace: editData.meetingPlace || "",
                    active: editData.active ?? true
                });
            } else {
                setFormData({
                    id: null,
                    name: "",
                    date: "",
                    time: "",
                    meetingPlace: "",
                    active: true
                });
            }
        }
    }, [editData, open]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        
        let sanitizedValue = value;

        // ✅ PROFESSIONAL SANITIZATION:
        // 1. .trimStart() removes leading spaces immediately even on paste
        // 2. .replace(/\s\s+/g, ' ') prevents multiple internal spaces
        if (name === "name" || name === "meetingPlace") {
            sanitizedValue = value.trimStart().replace(/\s\s+/g, ' ');
        }

        const finalValue = name === "active" ? sanitizedValue === "true" : sanitizedValue;
        
        setFormData(prev => ({ ...prev, [name]: finalValue }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        
        // Final cleanup of trailing spaces before sending to backend
        const meetingDto = {
            ...formData,
            name: formData.name.trim(),
            meetingPlace: formData.meetingPlace.trim(),
        };

        onSubmit(meetingDto);
    };

    if (!open) return null;

    return (
        <div className="staff-modal-overlay">
            <div className="staff-modal" style={{ width: '800px' }}>
                <div className="staff-modal-header">
                    <div className="staff-modal-title">
                        {editData ? t('pageTitles.editMeeting') : t('pageTitles.addMeeting')}
                    </div>
                    <button className="admin-modal-close" onClick={onClose} type="button">
                        <IoClose />
                    </button>
                </div>

                <div className="staff-form-body">
                    {error && <div className="staff-error-box">{error}</div>}

                    <form className="staff-form-grid" onSubmit={handleSubmit}>
                        
                        <div className="form-group col-span-full">
                            <label className="staff-modal-label">{t('forms.meeting.meetingTitle')} <span className="text-red-500">*</span></label>
                            <input
                                className="staff-modal-input"
                                name="name"
                                type="text"
                                value={formData.name}
                                onChange={handleChange}
                                placeholder="Enter Meeting Name"
                                required
                            />
                        </div>

                        <div className="form-group">
                            <label className="staff-modal-label">{t('common.date')} <span className="text-red-500">*</span></label>
                            <input
                                className="staff-modal-input"
                                name="date"
                                type="date"
                                value={formData.date}
                                onChange={handleChange}
                                required
                            />
                        </div>

                        <div className="form-group">
                            <label className="staff-modal-label">{t('common.time')} <span className="text-red-500">*</span></label>
                            <input
                                className="staff-modal-input"
                                name="time"
                                type="time"
                                value={formData.time}
                                onChange={handleChange}
                                required
                            />
                        </div>

                        <div className="form-group col-span-full">
                            <label className="staff-modal-label">{t('forms.meeting.meetingPlace')} <span className="text-red-500">*</span></label>
                            <input
                                className="staff-modal-input"
                                name="meetingPlace"
                                type="text"
                                value={formData.meetingPlace}
                                onChange={handleChange}
                                placeholder="Enter Meeting Place"
                                required
                            />
                        </div>

                        <div className="col-span-full staff-form-footer mt-4">
                            <button type="button" className="staff-btn-cancel" onClick={onClose}>{t('common.cancel')}</button>
                            <button type="submit" className="staff-btn-save">
                                {editData ? t('common.update') : t('common.save')}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default AddStaffMeetingForm;